// Service
import { backPreviousStateService } from 'services/back-state.service';
// Utils
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';

const backPreviousStateResolver = async (): Promise<[boolean]> => {
  const [, { status }] = await backPreviousStateService();

  return [requestHasSuccessStatus(status)];
};

export { backPreviousStateResolver };
